const breakpoints = {
  '0': 374,
  '12': 413,
  '25': 767,
  '50': 1023,
  '100': 1279,
  '200': 1365,
  '300': 1439,
  // breakpoint 400 goes from 1440 to infinite... will we just use largerThan(300)?
  //'400': metricConverter(767),
};

export { breakpoints };
